module.exports = __webpack_public_path__ + "static/service4-fda6dc6c476c9aa1a5db8ecfd4c418ee.png";